import React, { useEffect, useState } from 'react'
import Chart from '../Components/Chart/Chart'
import PieChart from '../Components/Chart/PieChart'
import { ManageApis } from '../AppServices/ManageApi'
import { all } from 'axios'
import { DatePicker, Message, Space } from '@arco-design/web-react'
import { useSearchParams } from 'react-router-dom'
import { async } from 'q'
import { Button } from 'react-bootstrap'
import moment from 'moment'
import Loader from '../Components/LoaderComponent/Loader'
import { getLocalStorage } from '../Functions/Utils'

var sd = '';
var ed = '';

function HitDashboard() {
    const [clientsNameList, setClientsNameList] = useState([{ id: 'all', name: 'All' }]);
    // const [currentTimeIntervel, setcurrentTimeIntervel] = useState('all')
    const [clientHits, setClientHits] = useState(0);
    const [clientServiceList, setclientServiceList] = useState([])
    const [dateRange, setDateRange] = useState(['']);
    const [loader, setloader] = useState(false);
    const [loader1, setloader1] = useState(false);
    const [loader2, setloader2] = useState(false);
    const [currentdate, setcurrentdate] = useState('')
    // const [currentStartDate, setCurrentStartDate] = useState('')
    // const [currentEndDate, setCurrentEndDate] = useState('')
    const [isVisible, setisVisible] = useState(false)
    var startDate = '';
    var endDate = "";
    const [currentClient, setcurrentClient] = useState('')
    const timeIntervals = [
        { id: 'all', name: 'All' },
        { id: 'this_week', name: 'This Week' },
        { id: 'this_month', name: 'This Month' },
        { id: 'last_3_months', name: 'Last 3 Months' },
        { id: 'this_year', name: 'This Year' },
        { id: 'custom', name: 'Custom' }
    ];
    const [allHitByMonth, setAllHitByMonth] = useState([])

    const [StatusCount, setStatusCount] = useState(
        {
            200: 0,
            406: 0,
            409: 0,
            422: 0
        }
    )
    useEffect(() => {
        getClientsListData()
        getAllHitByMonth()
        getAllClientServices()
    }, [])

    const getAllClientServices = async () => {
        setloader(true)
        let response = await ManageApis('get', global.getAllClientServices);
        if (response.message === "Success") {
            //console.log(response)
            setclientServiceList(response?.response_data.map(row => ({
                serviceName: row.serviceName,
                count: row.count,
            })))
            setloader(false)
        }
        else {
            setloader(false)
            //console.log(response)
        }
    }

    const getClientsListData = async () => {
        setloader1(true)
        try {

            let param = getLocalStorage("user_roll") == "Admin" ? "" : `?UserId=${getLocalStorage("clientId")}`
            let response = await ManageApis("get", global.getClientsList + param);
            //console.log(response);

            if (response.message === "Success") {

                const clientList = response?.response_data.map(row => ({
                    name: row.name,
                    id: row.id,
                }));
                setClientsNameList([{ id: 'all', name: 'All' }, ...clientList]);
                setloader1(false)

            } else {
                setloader1(false)
                //console.log(response)
                Message.error(response?.message)
            }
        } catch (error) {
            setloader1(false)
            //console.log(error)
        }
    };



    const handleChange = (e) => {

        setcurrentdate('')

        if (e.target.value == 'all') {
            setcurrentClient('')
        } else {
            setcurrentClient(e.target.value)
        }
    }

    const handleDateselect = (e) => {

        setcurrentdate(e.target.value)

        if (e.target.value == 'this_year') {
            setisVisible(false);
            endDate = moment().endOf('year').format('YYYY-MM-DD');
            startDate = moment().startOf('year').format('YYYY-MM-DD');
        }
        else if (e.target.value == 'all') {
            setisVisible(false);
            endDate = "";
            startDate = ""
        }
        else if (e.target.value == 'this_month') {
            setisVisible(false);
            endDate = moment().format('YYYY-MM-DD');
            startDate = moment().startOf('month').format('YYYY-MM-DD');
        }
        else if (e.target.value == 'this_week') {
            setisVisible(false);
            endDate = moment().format('YYYY-MM-DD');
            startDate = moment().startOf('week').format('YYYY-MM-DD');
        }
        else if (e.target.value == 'last_month') {
            setisVisible(false);
            endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');

        }
        else if (e.target.value == "last_3_months") {
            setisVisible(false);
            endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            startDate = moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD');

        }
        else if (e.target.value == "custom") {
            //console.log('hel')
            setisVisible(true);
        }

        if (e.target.value != "custom") {
            //api call
            getStatusCode()

        }

    }

    useEffect(() => {

        getStatusCode()

    }, [currentClient])


    useEffect(() => {
        setClientHits(StatusCount[200] + StatusCount[406] + StatusCount[409] + StatusCount[422])
    }, [StatusCount]
    )

    const getStatusCode = async () => {
        let status200 = await getHitsCountByStatusCode(200)
        let status406 = await getHitsCountByStatusCode(406)
        let status409 = await getHitsCountByStatusCode(409)
        let status422 = await getHitsCountByStatusCode(422)
        setStatusCount({ 200: status200, 406: status406, 409: status409, 422: status422 })
    }

    const getHitsCountByStatusCode = async (statusCode) => {
        setloader2(true)
        let paramClient = currentClient ? `ClientIds=${currentClient}` : ''
        let sdate = startDate ? `&StartDate=${startDate}` : ''
        let edate = endDate ? `&EndDate=${endDate}` : ''
        let response = await ManageApis('get', global.GetHitsCountByStatusCode + paramClient + sdate + edate + `&HttpStatusCodes=${statusCode}`)
        if (response.message == 'Success') {
            //console.log(response)
            let count = response?.response_data[0]?.count
            //console.log(count)
            if (response?.response_data.length > 1) {
                const total = response?.response_data.reduce((sum, item) => sum + item.count, 0);
                setloader2(false)

                return total;
            }
            else {
                setloader2(false)
                return count == undefined ? 0 : count
            }
        }
        else {
            setloader2(false)
            //console.log(response)
            return 0
        }
    }


    const getAllHitByMonth = async () => {
        setloader(true)
        let response = await ManageApis('get', global.getAllHitBymonth)
        if (response.message === "Success") {
            //console.log(response)
            setAllHitByMonth(response.response_data)
            setloader(false)

        }
        else {
            setloader(false)
            //console.log('error --- >', response)
        }
    }
    const extractChartData = () => {
        if (allHitByMonth.length === 0) {
            return { categories: [], series: [] };
        }
        const categories = allHitByMonth.map(item => item?.month);

        const series = Object.keys(allHitByMonth[0])
            .filter(key => key !== 'month')
            .map(key => ({
                name: key,
                data: allHitByMonth.map(item => item[key])
            }));

        return { categories, series };
    };

    const { categories, series } = extractChartData();
    const serviceNames = clientServiceList.map(item => item.serviceName);
    const counts = clientServiceList.map(item => item.count);

    // const handleDateChange = (e) => {
    //   setCurrentStartDate(e[0])
    //   setCurrentEndDate(e[1])
    //   //api call here to refresh graphs
    // }
    const onDateRangeChange = (dateRange) => {   //set value of rangepicker to usestate
        //console.log('Date range -->', dateRange)
        if (dateRange) {
            setDateRange(returnMomentDateRange(dateRange[0], dateRange[1]));

            //console.log('start date', dateRange[0])
            var startD = dateRange[0]
            var endD = dateRange[1]
            sd = convertDate(startD)
            ed = convertDate(endD)

        }
        //console.log("sd", sd, ed)

    };
    const returnMomentDateRange = (start, finish) => {   //to format date 

        return [moment(start, "YYYY-MM-DD"), moment(finish, "YYYY-MM-DD")];
    };
    const convertDate = (startD) => {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        var d = new Date(startD)
        return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
    }

    const handleFilter = () => {
        if (dateRange) {
            //console.log(dateRange)
            startDate = sd;
            endDate = ed;
            getStatusCode()

        }
        else {
            Notification.error("Please Select Date")
            //console.log(dateRange)
        }
    }
    const handleClear = () => {
        setcurrentClient('');
        setDateRange(['']);
        setClientHits(0);
        setcurrentdate('')

        getClientsListData()
        getAllHitByMonth()
        getAllClientServices()
    };
    return (
        <>
            {loader && <Loader />}
            {loader1 && <Loader />}
            {loader2 && <Loader />}
            <div className='px-2 overflow-auto hitDashBoard scrollbar1'>
                <div className='mb-3'>
                    <div className='d-flex justify-content-end'>

                        <div className={` ${isVisible ? "c " : " "}  d-inline-flex align-items-center gap-2`}>
                            <div className='d-flex flex-column w-100'>
                                <span className='font_14 fw_500 ws_nowrp'>
                                    Account Name
                                </span>
                                <select className="form-select rounded font_12" value={currentClient} onChange={(e) => handleChange(e, 'client')}>
                                    {clientsNameList?.map((itm) => (
                                        <option key={itm.id} value={itm.id}>{itm.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='d-flex flex-column w-100'>
                                <span className='font_14 fw_500 ws_nowrp'>
                                    Duration
                                </span>
                                <select className="form-select rounded font_12" onChange={handleDateselect} value={currentdate}>
                                    {timeIntervals?.map((itm) => (
                                        <option key={itm.id} value={itm.id}>{itm.name}</option>
                                    ))}
                                </select>
                            </div>



                            {/* <select className="form-control rounded font_12" style={{ display: currentTimeIntervel == 'custom' ? 'block' : 'none' }}>
                <option>he</option>
              </select> */}
                            {/* isVisible*/}
                            {isVisible &&
                                <>
                                    <div className='d-flex flex-column w-100'>
                                        {/* <DatePicker status='warning' placeholder='warning status' style={{ width: 200 }} /> */}
                                        <span className='font_14 fw_500 ws_nowrp'>
                                            Duration
                                        </span>
                                        <div className='arco_rangepicker w-100 min_w_230x'>

                                            <DatePicker.RangePicker value={dateRange} onChange={onDateRangeChange}
                                                style={{
                                                    width: "100%",
                                                    height: 40,
                                                    borderColor: "#eee",
                                                    backgroundColor: "transparent",
                                                }} />

                                        </div>
                                    </div>
                                    <div className='w-100'>
                                        <button className="btn px_btn btn-master px-3 py-2 rounded fw_500 font_12 w-100" onClick={handleFilter}>Filter</button>
                                    </div>

                                </>
                            }

                            <div className='w-100 '>
                                <button className="btn px_btn btn-master-line px-3 py-2 rounded fw_500 font_12 w-100" onClick={handleClear} >Clear</button>
                            </div>

                        </div>
                    </div>
                </div >
                <div className='mb-3'>
                    <h3 className='fw_600 font_18 text_master2 text-center mb-3 pt-2 '>Client Hit Count</h3>
                    <div className='border bg_master text-center p-3 fw_600 text-white rounded font_24'>{clientHits}</div>
                </div>
                <div className='mb-3'>
                    <div>
                        <div className='mx-0 row'>
                            <div className='col-12 col-md-6 '>
                                <div className='bg_light2 p-3 border br_5 overflow-hidden'>
                                    <h3 className='fw_600 font_15 text_master2 text-center me-5 mb-3 pt-2'>CLIENT HIT COUNT</h3>
                                    <div>
                                        <PieChart serie={Object.values(StatusCount)} />
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-md-6'>
                                <div className='bg_light2 p-3 border br_5 overflow-hidden'>
                                    <h3 className='fw_600 font_15 text_master2 text-center me-5 pe-5 mb-3 pt-2'>TOP SERVICES</h3>
                                    {serviceNames !== undefined && <div className='ps-4'>
                                        <PieChart labeld={serviceNames} serie={counts} />
                                    </div>}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='mb-3'>
                    <h3 className='fw_600 font_18 text_master2 text-center mb-3 pt-2'>Last 12 Months count</h3>
                    <div className='border shadow_sm p-2 rounded'>
                        <Chart categorie={categories} serie={series} />
                    </div>
                </div>
            </div >
        </>
    )
}

export default HitDashboard
